import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
function resolveAriaPressed(pressed, toggle, defaultPressed) {
  if (pressed !== void 0) {
    return pressed;
  }
  if (toggle) {
    return defaultPressed;
  }
  return void 0;
}
function invokeClickListener(listener, event) {
  if (typeof listener === "function") {
    listener(event);
    return;
  }
  if (listener != null && typeof listener === "object" && "handleEvent" in listener) {
    listener.handleEvent(event);
  }
}
export function RuiButton(props) {
  if (props.href !== void 0) {
    const {
      href,
      target,
      rel,
      download,
      children: children2,
      class: className2,
      variant: variant2,
      size: size2,
      square: square2,
      ...host2
    } = props;
    return /* @__PURE__ */jsx("a", {
      ...host2,
      href,
      target,
      rel,
      download,
      class: cx("rui-button", `rui-button--${variant2 ?? "filled"}`, `rui-button--${size2 ?? "md"}`, square2 && "rui-button--square", className2),
      children: children2
    });
  }
  const {
    variant,
    size,
    square,
    class: className,
    children,
    type = "button",
    disabled,
    pressed,
    defaultPressed = false,
    toggle = false,
    "on:click": onClick,
    ...host
  } = props;
  const handleClick = event => {
    if (toggle && pressed === void 0) {
      const button = event.currentTarget;
      const next = button.getAttribute("aria-pressed") !== "true";
      button.setAttribute("aria-pressed", String(next));
    }
    invokeClickListener(onClick, event);
  };
  return /* @__PURE__ */jsx("button", {
    ...host,
    type,
    class: cx("rui-button", `rui-button--${variant ?? "filled"}`, `rui-button--${size ?? "md"}`, square && "rui-button--square", className),
    disabled,
    "aria-pressed": resolveAriaPressed(pressed, toggle, defaultPressed),
    "data-toggle": toggle && pressed === void 0 ? "" : void 0,
    "on:click": toggle || onClick ? handleClick : void 0,
    children
  });
}